import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const FIELDS_MAP = {
  journal: [
    { name: 'title', label: 'Journal Title', type: 'text' },
    { name: 'shortTitle', label: 'Short Title / Abbreviation', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'field', label: 'Research Field', type: 'text' },
    { name: 'frequency', label: 'Publication Frequency', type: 'text' },
  ],
  board: [
    { name: 'name', label: 'Full Name', type: 'text' },
    { name: 'title', label: 'Academic Title / Position', type: 'text' },
    { name: 'institution', label: 'Institution / Organization', type: 'text' },
    { name: 'role', label: 'Role', type: 'text' },
  ],
};

const AdminEditModal = ({ isOpen, type = 'journal', item, onSave, onClose }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (item) setFormData({ ...item });
  }, [item]);

  if (!isOpen || !item) return null;

  const fields = FIELDS_MAP[type] || [];

  const handleChange = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="edit-modal">
      <div className="bg-white border border-[#E5E7EB] max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB] sticky top-0 bg-white">
          <h3 className="font-semibold text-[#1F1F1F] text-sm">
            Edit {type === 'journal' ? 'Journal Details' : 'Board Member Profile'}
          </h3>
          <button onClick={onClose} className="text-[#9CA3AF] hover:text-[#6B7280]" data-testid="edit-modal-close">
            <X size={15} />
          </button>
        </div>
        <div className="px-6 py-5 space-y-4">
          {fields.map(field => (
            <div key={field.name}>
              <label className="block text-xs font-semibold text-[#374151] uppercase tracking-wide mb-1.5">{field.label}</label>
              {field.type === 'textarea' ? (
                <textarea name={field.name} value={formData[field.name] || ''} onChange={handleChange} rows={4}
                  className="w-full px-3 py-2 border border-[#E5E7EB] text-sm text-[#1F1F1F] focus:outline-none focus:ring-1 focus:ring-[#1A73E8] focus:border-[#1A73E8] resize-none"
                  data-testid={`edit-field-${field.name}`} />
              ) : (
                <input type="text" name={field.name} value={formData[field.name] || ''} onChange={handleChange}
                  className="w-full px-3 py-2 border border-[#E5E7EB] text-sm text-[#1F1F1F] focus:outline-none focus:ring-1 focus:ring-[#1A73E8] focus:border-[#1A73E8]"
                  data-testid={`edit-field-${field.name}`} />
              )}
            </div>
          ))}
        </div>
        <div className="px-6 pb-5 flex gap-2 justify-end border-t border-[#E5E7EB] pt-4">
          <button onClick={onClose} className="px-4 py-2 border border-[#E5E7EB] text-sm text-[#374151] hover:bg-[#F5F7FA] transition-colors">
            Cancel
          </button>
          <button onClick={() => onSave(formData)} className="px-4 py-2 bg-[#1A73E8] text-white text-sm hover:bg-[#174EA6] transition-colors" data-testid="edit-save-btn">
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminEditModal;
